/**
 * Shamelessly stolen from recompose
 * https://github.com/acdlite/recompose/blob/master/docs/API.md#setstatic
 */

const setStatic = (key, value) => (BaseComponent) => {
  /* eslint-disable no-param-reassign */
  BaseComponent[key] = value;
  /* eslint-enable no-param-reassign */

  return BaseComponent;
};

export default setStatic;
